import React from 'react'
import Slider from "react-slick";
import ChatNow from '../chatnow';
const AreasWeCover = () => {
    const slider = React.useRef(null);

    var settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                }
            },
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                }
            }
        ]
    };


    return (
        <div className='min-h-screen py-12 bg-primary relative' id="areawecover">
            <div className='container mx-auto'>
                <div className='p-5'>
                    <p className='text-center text-white'>Areas We Cover</p>
                    <h2 className='text-center text-white text-5xl md:text-6xl font-bold mt-5 max-w-[850px] mx-auto'>
                        Car Accident In New York? We’ve Got You Covered
                    </h2>
                </div>
                <div className='py-4 px-5 relative'>
                    <button className='absolute z-10 left-0 md:-left-4 top-1/2' onClick={() => slider?.current?.slickPrev()} >
                        <img src='/assets/images/arrow-left.png' alt="" className='w-20 h-20' />
                    </button>
                    <div className=''>
                        <Slider {...settings} ref={slider}>
                            <div className='flex flex-col justify-center items-center text-center md:p-5'>
                                <img src='/assets/images/negligent-driver-icon.png' alt="" />
                                <p className='text-white max-w-[150px] text-center  mx-auto'>Car Collision</p>
                            </div>
                            <div className='flex flex-col justify-center items-center text-center md:p-5'>
                                <img src='/assets/images/car-collission-icon.png' alt="" />
                                <p className='text-white max-w-[150px] text-center  mx-auto'>Car
                                    Collission</p>
                            </div>
                            <div className='flex flex-col justify-center items-center text-center md:p-5'>
                                <img src='/assets/images/hit-and-run -accident.png' alt="" />
                                <p className='text-white max-w-[150px] text-center  mx-auto'>Hit & Run
                                    Accident</p>
                            </div>
                            <div className='flex flex-col justify-center items-center text-center md:p-5'>
                                <img src='/assets/images/property-damage.png' alt="" />
                                <p className='text-white max-w-[150px] text-center mx-auto'>Property
                                    Damage</p>
                            </div>
                        </Slider>
                    </div>
                    <button onClick={() => slider?.current?.slickNext()} className='absolute right-0 md:-right-4 top-1/2 '>
                        <img src='/assets/images/arrow-right.png' alt="" className='w-20 h-20' />
                    </button>
                </div>
                <div className='absolute max-sm:left-0 right-0 bottom-2 sm:right-14 p-4'>
                <ChatNow variant="white" text="Chat now!" />
            </div>
            </div>
        </div>
    )
}

export default AreasWeCover